import React, {useEffect, useState} from "react";

import axios from "config/axiosConfig";
import {useLocation, useNavigate} from "react-router-dom";
import dateFormat from "dateformat";

export default function AppVersion() {
    const [appVersion, setAppVersion] = useState();
    const [inputAppVersion, setInputAppVersion] = useState('');

    const requestSaveAppVersion = () => {
        const params = new FormData();
        params.append("version", inputAppVersion);
        axios.post(`/admin/app/version`, params, {
            headers: {'content-type': 'application/x-www-form-urlencoded'}
        })
        .then((res) => {
            alert('앱 버전이 수정되었습니다.');
            window.location.reload();
        });
    }

    useEffect(() => {
        axios.get(`/admin/app/versions/latest`)
        .then((res) => {
           setAppVersion(res.data);
        });
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">앱 버전</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">

                                        <div className="card-tools">
                                            <button type="button"
                                                    className="btn btn-outline-primary btn-sm float-right"
                                                    style={{width: '70px', marginRight: '20px', marginTop: '4px'}}
                                                    onClick={requestSaveAppVersion}>
                                                저장
                                            </button>


                                            <div className="col-sm-2 float-right">
                                                <input type="text" className="form-control float-right" id="pushContent"
                                                       onChange={e => {
                                                           const value = e.target.value;
                                                           if (/^[0-9.]*$/.test(value)) { // 숫자와 . 만 허용
                                                               setInputAppVersion(value);
                                                           }
                                                       }}
                                                       value={inputAppVersion}
                                                />
                                            </div>

                                            <label className="col-form-label float-right" style={{marginRight: '20px'}}>앱버전</label>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>id</th>
                                                    <th>등록일</th>
                                                    <th>앱버전</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{appVersion && appVersion.id}</td>
                                                        <td>{appVersion && appVersion.createdAt}</td>
                                                        <td>{appVersion && appVersion.version}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    )
}